import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/payment-detail-screen.module.scss';
import { IPayment } from 'src/types/payment';
import RoleLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { IServiceType } from '../../../../../../types/service-types';
import { IInvoice } from '../../../../../../types/invoice';
import DetailForm, { PaymentFormData } from '../../components/DetailPaymentForm';
import { QueryParams } from '../../../../../../types/grid';
import Loader from '../../../../../../components/Loader';
import CaseEnum from '../../../../../../enumerables/case-enum';
import { getValFromEnum } from '../../../../../../components/redux-form/utils/dropdown-values';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';

export interface StateProps {
    payment: IPayment | null;
    inProgress: boolean;
    students: SelectObject[];
    vendors: SelectObject[];
    districts: SelectObject[];
    providers: SelectObject[];
    serviceTypes: Paginated<IServiceType>;
    invoices: Paginated<IInvoice>;
    valuesForm: Partial<PaymentFormData>;
    caseNumbers: { [key: string]: string | null }[];
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getStudents: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getInvoices: (params: QueryParams) => void;
    getCaseNumbers: () => void;
}
interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {
    history: any;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const PaymentInfo: FC<Props> = (props: Props) => {
    const {
        payment,
        match: {
            params: { id },
        },
        getStudents,
        getDistricts,
        getVendors,
        getServiceTypes,
        invoices,
        getInvoices,
        getProviders,
        students,
        vendors,
        providers,
        districts,
        serviceTypes,
        valuesForm,
        getCaseNumbers,
        caseNumbers,
        getData,
        inProgress,
    } = props;
    const [stateInvoice, setStateInvoice] = useState<any>({
        list: [],
        page: 1,
        invoiceIds: [],
        isFilterOn: false,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    });
    useEffect(() => {
        if (typeof invoices.totalPages === 'number' && payment && `${payment?.id}` === id) {
            if (stateInvoice.withIds && !inProgress) {
                if (stateInvoice.invoiceIds.length) {
                    const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.invoiceIds);

                    const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                    const uniq: ListType<IInvoice> = [...some];
                    setStateInvoice({
                        ...stateInvoice,
                        ...invoices,
                        list: uniq,
                        inProgress: false,
                        withIds: true,
                        isFilterOn: true,
                    });
                } else {
                    const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.list);

                    const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                    const uniq: ListType<IInvoice> = [...some];

                    setStateInvoice({
                        ...stateInvoice,
                        ...invoices,
                        invoiceIds: invoices.list,
                        list: uniq,
                        inProgress: false,
                        withIds: true,
                    });
                }
            } else {
                setTimeout(() => {
                    const arrMerge: ListType<IInvoice> = invoices.list.concat(stateInvoice.list);
                    const some: any = new Map(arrMerge.map((item: any) => [item['id'], item])).values();
                    const uniq: ListType<IInvoice> = [...some];

                    setStateInvoice({
                        ...stateInvoice,
                        ...invoices,
                        list: uniq,

                        inProgress: false,
                        withIds: true,
                    });
                }, 500);
            }

            setTimeout(() => {
                if (!inProgress && !stateInvoice.withIds && payment?.paymentInvoices.length) {
                    const invs: any = [];

                    payment.paymentInvoices.forEach((it: any) => {
                        invs.push(it?.invoice?.id);
                    });
                    getInvoices({
                        page: 1,
                        itemsPerPage: 9000,
                        filters: {
                            id: invs,
                        },
                    });
                }
            }, 500);
        }
        // eslint-disable-next-line
    }, [inProgress, invoices]);
    useEffect(() => {
        if (!payment || payment.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (payment?.id) {
            getStudents({
                page: 1,
                itemsPerPage: 9000,
            });
            getProviders({
                page: 1,
                itemsPerPage: 1200,
            });

            getCaseNumbers();
            getDistricts({
                page: 1,
                itemsPerPage: 9000,
            });
            getVendors({
                page: 1,
                itemsPerPage: 9000,
            });
            getServiceTypes({
                page: 1,
                itemsPerPage: 9000,
            });
        }

        // eslint-disable-next-line
    }, [payment?.id, getVendors, getServiceTypes, getDistricts, getStudents]);

    let amount: any = 0;
    let paymentCredits: any = [];
    if (valuesForm) {
        amount = valuesForm.amount ? valuesForm.amount : 0;
        paymentCredits = valuesForm.paymentCredits ? valuesForm.paymentCredits : [];
    }

    let stateAmount = 0;
    let amountCredits = 0;

    const [stateData, setStateData] = useState<any>({});
    Object.keys(stateData).forEach((k: string) => {
        stateAmount += stateData[k].remainingAmount ? +stateData[k].remainingAmount : 0;
    });
    paymentCredits.forEach((it: any) => {
        if (+it.status !== 2) {
            amountCredits += it.amount ? +it.amount : 0;
        }
    });

    useEffect(() => {
        const dataStateInit: any = {};
        if (payment) {
            invoices.list.forEach((it: IInvoice) => {
                it.paymentInvoices.forEach((itP: any) => {
                    if (+itP.payment.id === +payment.id && !itP.paymentCredit) {
                        dataStateInit[+it.id] = { action: true, remainingAmount: itP.amount };
                    }
                });
            });
        }
        if (Object.values(dataStateInit).length) {
            setStateData(dataStateInit);
        }
        // eslint-disable-next-line
    }, [invoices]);

    const totalAmount: number = +amountCredits + +stateAmount;
    const remainAmount: number = +amount - +totalAmount;

    const typeEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const caseTypes: SelectObject[] = getValFromEnum(typeEnum);
    const valueCaseType = caseTypes.find((it) => it.value === payment?.caseType);
    const caseTypeObj = valueCaseType ? valueCaseType : {};

    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'PAYMENTS', path: routes.PAYMENTS_LIST },
                    { name: id ? `${id}` : '', path: '' },
                ]}
            />
            {!payment ? <Loader /> : null}
            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.editWrap)}>
                    {!payment ? (
                        <Loader />
                    ) : (
                        <DetailForm
                            students={students}
                            handleSub={() => false}
                            vendors={vendors}
                            invoices={{ ...stateInvoice, inProgress: invoices?.inProgress }}
                            amountValue={amount}
                            districts={districts}
                            providers={providers}
                            getData={getInvoices}
                            stateData={stateData}
                            caseNumbers={caseNumbers}
                            setStateData={setStateData}
                            serviceTypes={serviceTypes}
                            paymentCredits={payment?.paymentCredits}
                            initialValues={{ ...payment }}
                            caseTypeHistory={caseTypeObj}
                            remainAmount={remainAmount}
                            totalAmount={totalAmount}
                        />
                    )}
                </div>

                <div>
                    <Link
                        className={classNames('btn', 'btn-outline-secondary')}
                        to={Router.generate(routes.PAYMENT_EDIT, { id })}
                    >
                        EDIT
                    </Link>
                </div>
            </div>
        </RoleLayout>
    );
};

export default PaymentInfo;
